import { useContext } from 'react';
import { ProfilingContext } from '../context/profiling';

export const useProfiling = () => useContext(ProfilingContext);
